<!--
 * @Description  : 
 * @Author       : BigBigger
 * @Date         : 2021-11-12 09:43:05
 * @LastEditTime : 2025-10-12 16:10:10
 * @LastEditors  : BigBigger
-->
<template>
  <div class="foot" v-if="showTabBar">
    <van-tabbar @change="onChange" v-model="active" active-color="#FF3F47" inactive-color="#999">
      <van-tabbar-item name="/course" icon="column">课程</van-tabbar-item>
      <van-tabbar-item name="/lesson" icon="live">上课</van-tabbar-item>
      <van-tabbar-item name="/mine" icon="manager">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
export default {
  name: "Foot",
  data() {
    return {
      active: '/course'
    }
  },
  mounted() {
    let path = this.$route.path
    if(path === '/') {
      path = '/course'
    }
    this.active = path
  },
  computed: {
    showTabBar() {
      let name = this.$route.name;
      // console.log('name', name)
      return ['home', 'Lesson', 'Mine', 'Course', null].includes(this.$route.name)
    }
  },
  methods: {
    onChange(e) {
      this.$router.push({path:e})
    }
  },
  watch: {
    '$route': {
      handler() {
        let path = this.$route.path
        if(path === '/') {
          path = '/course'
        }
        this.active = path
      },
      deep: true,
    }
  }
}
</script>
<style lang="less">

</style>